import React from 'react';

const TermsPage: React.FC = () => {
  return (
    <div className="page-shell">
      <div className="container">
        <div className="page-intro">
          <div>
            <p className="eyebrow">Community guidelines</p>
            <h1 className="page-heading">GLSN Discussion Policy</h1>
            <p className="page-copy">
              These guidelines explain how to take part in the Great Lakes Severe Network community,
              including discussions, severe weather reports, and staff-only operational pages.
            </p>
          </div>
        </div>

        <div className="alert alert-error">
          Great Lakes Severe Network is independently operated and is not affiliated with the National Weather
          Service or NOAA.
        </div>

        <div className="card">
          <div className="simple-stack">
            <section>
              <h2 className="section-heading">Be respectful and accurate</h2>
              <p className="page-copy">
                Use the platform for constructive weather discussion and coordination. Do not submit false
                reports, attempt unauthorized access, interfere with platform operations, scrape protected
                staff tools, or abuse account features.
              </p>
            </section>

            <section>
              <h2 className="section-heading">How account data is handled</h2>
              <p className="page-copy">
                Great Lakes Severe Network does not fetch or store visitor IP addresses through this application.
                Your local viewing activity and browsing remain on your own device.
              </p>
              <p className="page-copy">
                The only account data sent to our servers during account creation and sign-in is:
              </p>
              <ul className="plain-list">
                <li>Your username</li>
                <li>The name you provide for your account</li>
                <li>Your password as a bcrypt hash value</li>
              </ul>
            </section>

            <section>
              <h2 className="section-heading">Weather content and operational use</h2>
              <p className="page-copy">
                Discussions, report workflows, and related operational content are provided for informational
                and coordination purposes. They do not replace official forecasts, warnings, statements,
                or other products issued by the National Weather Service.
              </p>
            </section>

            <section>
              <h2 className="section-heading">User submissions</h2>
              <p className="page-copy">
                By submitting severe weather reports, attachments, and account details, you represent that the
                information is accurate to the best of your knowledge and that you have the right to provide it.
                Great Lakes Severe Network may review, remove, or retain submissions for moderation,
                operations, and audit purposes.
              </p>
            </section>

            <section>
              <h2 className="section-heading">Accounts and access</h2>
              <p className="page-copy">
                Staff and elevated access are granted at administrator discretion. Accounts may be limited,
                suspended, or removed if they are used improperly or if continued access is no longer
                appropriate for operational reasons.
              </p>
            </section>

            <section>
              <h2 className="section-heading">Availability and updates</h2>
              <p className="page-copy">
                Great Lakes Severe Network may update, suspend, or remove features, policies, and content at any time.
                Continued use of the platform after changes are posted means you accept the updated terms.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;